import { load } from "../localStorage"

const GLOBAL_STORAGE_KEY = "data"

const weightLossTable = {
  "-39": "100.0%",
  "-38": "99.5%",
  "-37": "99.1%",
  "-36": "98.6%",
  "-35": "98.2%",
  "-34": "97.7%",
  "-33": "97.3%",
  "-32": "96.8%",
  "-31": "96.4%",
  "-30": "95.9%",
  "-29": "95.5%",
  "-28": "95.0%",
  "-27": "94.5%",
  "-26": "94.1%",
  "-25": "93.6%",
  "-24": "93.2%",
  "-23": "92.7%",
  "-22": "92.3%",
  "-21": "91.8%",
  "-20": "91.4%",
  "-19": "90.9%",
  "-18": "90.5%",
  "-17": "90.0%",
  "-16": "89.5%",
  "-15": "89.1%",
  "-14": "88.0%",
  "-13": "88.2%",
  "-12": "87.7%",
  "-11": "87.3%",
  "-10": "86.8%",
  "-9": "86.4%",
  "-8": "85.9%",
  "-7": "85.5%",
  "-6": "85.0%",
  "-5": "84.5%",
  "-4": "84.1%",
  "-3": "83.6%",
  "-2": "83.2%",
  "-1": "82.7%",
  0: "82.3%",
  1: "81.8%",
  2: "81.4%",
  3: "80.9%",
  4: "80.5%",
  5: "80.0%",
  6: "79.5%",
  7: "79.1%",
  8: "78.6%",
  9: "78.2%",
  10: "77.7%",
  11: "77.3%",
  12: "76.8%",
  13: "76.4%",
  14: "75.9%",
  15: "75.5%",
  16: "75.0%",
  17: "74.5%",
  18: "74.1%",
  19: "73.6%",
  20: "73.2%",
  21: "72.7%",
  22: "72.3%",
  23: "71.8%",
  24: "71.4%",
  25: "70.9%",
  26: "70.5%",
  27: "70.0%",
}

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  populateFormValuesFromStorage() {
    const globalData = load(GLOBAL_STORAGE_KEY)

    this.formValues = globalData.values

    this.getButtonState()
  },

  scores() {
    return {
      sixMonthsWeightLoss: {
        [AlpineI18n.t("02-test.answerOne")]: -1,
        [AlpineI18n.t("02-test.answerTwo")]: 0,
        [AlpineI18n.t("02-test.answerThree")]: 0,
      },
      snackHungryOption: {
        [AlpineI18n.t("13-test.answerOne")]: -1,
        [AlpineI18n.t("13-test.answerTwo")]: -1,
        [AlpineI18n.t("13-test.answerThree")]: 1,
      },
      snackStressOption: {
        [AlpineI18n.t("14-test.answerOne")]: -1,
        [AlpineI18n.t("14-test.answerTwo")]: -1,
        [AlpineI18n.t("14-test.answerThree")]: 1,
      },
      smokingAtLeastFiveCigaretesPerWeek: {
        [AlpineI18n.t("15-test.answerOne")]: 1,
        [AlpineI18n.t("15-test.answerTwo")]: -1,
      },
      smokingAtLeastTwentyCigaretesPerMonth: {
        [AlpineI18n.t("16-test.answerOne")]: 1,
        [AlpineI18n.t("16-test.answerTwo")]: -1,
      },
      averageSleepingTime: {
        [AlpineI18n.t("17-test.answerOne")]: 1,
        [AlpineI18n.t("17-test.answerTwo")]: 1,
        [AlpineI18n.t("17-test.answerThree")]: -1,
      },
      bloatingExperienceOccurence: {
        [AlpineI18n.t("18-test.answerOne")]: -1,
        [AlpineI18n.t("18-test.answerTwo")]: -1,
        [AlpineI18n.t("18-test.answerThree")]: 0,
      },
      hormonalMedicinesUsage: {
        [AlpineI18n.t("20-test.answerOne")]: 1,
        [AlpineI18n.t("20-test.answerTwo")]: -1,
      },
      antiDepresantsUsage: {
        [AlpineI18n.t("21-test.answerOne")]: 1,
        [AlpineI18n.t("21-test.answerTwo")]: -1,
      },
      foodSuplementsOrVitaminsUsage: {
        [AlpineI18n.t("22-test.answerOne")]: 0,
        [AlpineI18n.t("22-test.answerTwo")]: 1,
      },
      chronicOrAcuteDisease: {
        [AlpineI18n.t("23-test.no")]: 1,
        [AlpineI18n.t("23-test.cardiovascularDiseases")]: -1,
        [AlpineI18n.t("23-test.diabetes")]: -1,
        [AlpineI18n.t("23-test.gout")]: 0,
        [AlpineI18n.t("23-test.diseasesOfGastrointestinalTract")]: -1,
        [AlpineI18n.t("23-test.oncologicalDiseases")]: 0,
        [AlpineI18n.t("23-test.cholesterolProblems")]: -1,
        [AlpineI18n.t("23-test.otherDiseases")]: 0,
      },
      healthComplaints: {
        [AlpineI18n.t("24-test.optionOne")]: 1,
        [AlpineI18n.t("24-test.optionTwo")]: -1,
        [AlpineI18n.t("24-test.optionThree")]: -1,
        [AlpineI18n.t("24-test.optionFour")]: 0,
        [AlpineI18n.t("24-test.optionFive")]: -1,
        [AlpineI18n.t("24-test.optionSix")]: -1,
        [AlpineI18n.t("24-test.optionSeven")]: 0,
      },
      beefEatingOccurence: {
        [AlpineI18n.t("25-test.answerOne")]: 1,
        [AlpineI18n.t("25-test.answerTwo")]: 1,
        [AlpineI18n.t("25-test.answerThree")]: 0,
        [AlpineI18n.t("25-test.answerFour")]: -1,
        [AlpineI18n.t("25-test.answerFive")]: -1,
      },
      weightLossAttemptsInLast12Months: {
        [AlpineI18n.t("28-test.answerOne")]: 0,
        [AlpineI18n.t("28-test.answerTwo")]: -1,
        [AlpineI18n.t("28-test.answerThree")]: 0,
      },
      hungryFeelingAfterMealPeriod: {
        [AlpineI18n.t("30-test.answerOne")]: -1,
        [AlpineI18n.t("30-test.answerTwo")]: -1,
        [AlpineI18n.t("30-test.answerThree")]: 0,
      },
      feelingSleepyAfterMealOccurence: {
        [AlpineI18n.t("31-test.answerOne")]: 1,
        [AlpineI18n.t("31-test.answerTwo")]: 0,
        [AlpineI18n.t("31-test.answerThree")]: -1,
        [AlpineI18n.t("31-test.answerFour")]: -1,
        [AlpineI18n.t("31-test.answerFive")]: 1,
      },
      restaurantOrderingHabits: {
        [AlpineI18n.t("33-test.answerOne")]: 1,
        [AlpineI18n.t("33-test.answerTwo")]: -1,
      },
      firstMealTime: {
        [AlpineI18n.t("34-test.answerOne")]: 1,
        [AlpineI18n.t("34-test.answerTwo")]: 1,
        [AlpineI18n.t("34-test.answerThree")]: -1,
      },
      overeatPeriod: {
        [AlpineI18n.t("35-test.answerOne")]: -1,
        [AlpineI18n.t("35-test.answerTwo")]: -1,
        [AlpineI18n.t("35-test.answerThree")]: -1,
        [AlpineI18n.t("35-test.answerFour")]: 1,
      },
      cookingHabits: {
        [AlpineI18n.t("36-test.answerOne")]: 0,
        [AlpineI18n.t("36-test.answerTwo")]: 0,
        [AlpineI18n.t("36-test.answerThree")]: -1,
      },
      mealPreparingAvgTime: {
        [AlpineI18n.t("37-test.answerOne")]: -1,
        [AlpineI18n.t("37-test.answerTwo")]: -1,
        [AlpineI18n.t("37-test.answerThree")]: 1,
        [AlpineI18n.t("37-test.answerFour")]: 1,
      },
      eggsPerWeek: {
        [AlpineI18n.t("39-test.answerOne")]: -1,
        [AlpineI18n.t("39-test.answerTwo")]: -1,
        [AlpineI18n.t("39-test.answerThree")]: 0,
        [AlpineI18n.t("39-test.answerFour")]: 0,
        [AlpineI18n.t("39-test.answerFive")]: 0,
      },
      vegetablesPerDay: {
        [AlpineI18n.t("40-test.answerOne")]: -1,
        [AlpineI18n.t("40-test.answerTwo")]: 0,
        [AlpineI18n.t("40-test.answerThree")]: 1,
        [AlpineI18n.t("40-test.answerFour")]: 1,
      },
      amountOfWaterDuringMeal: {
        [AlpineI18n.t("41-test.metric.answerOne")]: 0,
        [AlpineI18n.t("41-test.metric.answerTwo")]: 0,
        [AlpineI18n.t("41-test.metric.answerThree")]: -1,
        [AlpineI18n.t("41-test.metric.answerFour")]: -1,
        [AlpineI18n.t("41-test.metric.answerFive")]: 0,
        [AlpineI18n.t("41-test.imperial.answerOne")]: 0,
        [AlpineI18n.t("41-test.imperial.answerTwo")]: 0,
        [AlpineI18n.t("41-test.imperial.answerThree")]: -1,
        [AlpineI18n.t("41-test.imperial.answerFour")]: -1,
        [AlpineI18n.t("41-test.imperial.answerFive")]: 0,
      },
      waterIntakeAmount: {
        [AlpineI18n.t("42-test.metric.answerOne")]: 1,
        [AlpineI18n.t("42-test.metric.answerTwo")]: 1,
        [AlpineI18n.t("42-test.metric.answerThree")]: -1,
        [AlpineI18n.t("42-test.metric.answerFour")]: -1,
        [AlpineI18n.t("42-test.imperial.answerOne")]: 1,
        [AlpineI18n.t("42-test.imperial.answerTwo")]: 1,
        [AlpineI18n.t("42-test.imperial.answerThree")]: -1,
        [AlpineI18n.t("42-test.imperial.answerFour")]: -1,
      },
      coffeeIntakeAmount: {
        [AlpineI18n.t("43-test.answerOne")]: -1,
        [AlpineI18n.t("43-test.answerTwo")]: -1,
        [AlpineI18n.t("43-test.answerThree")]: 0,
        [AlpineI18n.t("43-test.answerFour")]: 0,
      },
      averageWorkingDay: {
        [AlpineI18n.t("44-test.answerOne")]: -1,
        [AlpineI18n.t("44-test.answerTwo")]: 1,
        [AlpineI18n.t("44-test.answerThree")]: 1,
      },
      snackOfChoiceInLast30Days: {
        [AlpineI18n.t("45-test.answerOne")]: -1,
        [AlpineI18n.t("45-test.answerTwo")]: -1,
        [AlpineI18n.t("45-test.answerThree")]: -1,
        [AlpineI18n.t("45-test.answerFour")]: -1,
        [AlpineI18n.t("45-test.answerFive")]: 1,
      },
      eatingHabitsDifferentDuringWeekend: {
        [AlpineI18n.t("46-test.answerOne")]: 1,
        [AlpineI18n.t("46-test.answerTwo")]: -1,
      },
      eatingPlace: {
        [AlpineI18n.t("48-test.answerOne")]: 1,
        [AlpineI18n.t("48-test.answerTwo")]: -1,
        [AlpineI18n.t("48-test.answerThree")]: -1,
        [AlpineI18n.t("48-test.answerFour")]: -1,
      },
      hardLiquorAmount: {
        [AlpineI18n.t("49-test.answerOne")]: -1,
        [AlpineI18n.t("49-test.answerTwo")]: -1,
        [AlpineI18n.t("49-test.answerThree")]: -1,
        [AlpineI18n.t("49-test.answerFour")]: 0,
        [AlpineI18n.t("49-test.answerFive")]: 1,
      },
      lightAlcoholAmount: {
        [AlpineI18n.t("50-test.answerOne")]: -1,
        [AlpineI18n.t("50-test.answerTwo")]: -1,
        [AlpineI18n.t("50-test.answerThree")]: 0,
        [AlpineI18n.t("50-test.answerFour")]: 0,
        [AlpineI18n.t("50-test.answerFive")]: 1,
      },
      workingOutOccurence: {
        [AlpineI18n.t("51-test.answerOne")]: 1,
        [AlpineI18n.t("51-test.answerTwo")]: 1,
        [AlpineI18n.t("51-test.answerThree")]: -1,
        [AlpineI18n.t("51-test.answerFour")]: -1,
      },
      walkingOccurence: {
        [AlpineI18n.t("52-test.answerOne")]: -1,
        [AlpineI18n.t("52-test.answerTwo")]: 0,
        [AlpineI18n.t("52-test.answerThree")]: 1,
        [AlpineI18n.t("52-test.answerFour")]: 1,
      },
      overWeightCausedProblems: {
        [AlpineI18n.t("56-test.weightCausedProblemsOneWomen")]: 0,
        [AlpineI18n.t("56-test.weightCausedProblemsTwoWomen")]: 1,
        [AlpineI18n.t("56-test.weightCausedProblemsThreeWomen")]: 1,
        [AlpineI18n.t("56-test.weightCausedProblemsOneMan")]: 0,
        [AlpineI18n.t("56-test.weightCausedProblemsTwoMan")]: 1,
        [AlpineI18n.t("56-test.weightCausedProblemsThreeMan")]: 1,
      },
    }
  },

  selectedBodyPart() {
    if (this.formValues["bodyParts"] === null) return AlpineI18n.t("54-test.stomach").toLowerCase()

    return this.formValues["bodyParts"][0].toLowerCase()
  },

  capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  },

  resultsSentenceOne(formattedWeightToLose) {
    const { sixMonthsWeightLoss } = this.formValues

    if (AlpineI18n.t("02-test.answerOne") === sixMonthsWeightLoss) {
      return AlpineI18n.t("60-results.sentenceOne.versionOne")
    }
    if (AlpineI18n.t("02-test.answerTwo") === sixMonthsWeightLoss) {
      return AlpineI18n.t("60-results.sentenceOne.versionTwo", {
        weightToLose: formattedWeightToLose,
      })
    }
    return AlpineI18n.t("60-results.sentenceOne.versionThree", {
      weightToLose: formattedWeightToLose,
    })
  },

  resultsSentenceTwo() {
    const { betterAppetitePeriod } = this.formValues

    if (AlpineI18n.t("12-test.answerOne") === betterAppetitePeriod) {
      return AlpineI18n.t("60-results.sentenceTwo.versionOne")
    }
    if (AlpineI18n.t("12-test.answerTwo") === betterAppetitePeriod) {
      return AlpineI18n.t("60-results.sentenceTwo.versionTwo")
    }
    return AlpineI18n.t("60-results.sentenceTwo.versionThree")
  },

  resultsSentenceThree() {
    const { snackStressOption } = this.formValues

    if (AlpineI18n.t("14-test.answerOne") === snackStressOption) {
      return AlpineI18n.t("60-results.sentenceThree.versionOne")
    }
    if (AlpineI18n.t("14-test.answerTwo") === snackStressOption) {
      return AlpineI18n.t("60-results.sentenceThree.versionTwo")
    }
  },

  resultsSentenceFour() {
    const { smokingAtLeastFiveCigaretesPerWeek } = this.formValues

    if (AlpineI18n.t("15-test.answerTwo") === smokingAtLeastFiveCigaretesPerWeek) {
      return AlpineI18n.t("60-results.sentenceFour.versionOne")
    }
  },

  resultsSentenceFive() {
    const { averageSleepingTime } = this.formValues

    if (AlpineI18n.t("17-test.answerTwo") === averageSleepingTime) {
      return AlpineI18n.t("60-results.sentenceFive.versionOne")
    }
    if (AlpineI18n.t("17-test.answerThree") === averageSleepingTime) {
      return AlpineI18n.t("60-results.sentenceFive.versionTwo")
    }
  },

  resultsSentenceSix() {
    return AlpineI18n.t("60-results.sentenceSix.versionOne")
  },

  resultsSentenceSeven() {
    const { hormonalMedicinesUsage } = this.formValues

    if (AlpineI18n.t("20-test.answerTwo") === hormonalMedicinesUsage) {
      return AlpineI18n.t("60-results.sentenceSeven.versionOne")
    }
  },

  resultsSentenceEight() {
    const { antiDepresantsUsage } = this.formValues

    if (AlpineI18n.t("21-test.answerTwo") === antiDepresantsUsage) {
      return AlpineI18n.t("60-results.sentenceEight.versionOne")
    }
  },

  resultsSentenceNine(formattedWeightToLose) {
    const { chronicOrAcuteDisease, age } = this.formValues

    let sentence = []

    if (chronicOrAcuteDisease.includes(AlpineI18n.t("23-test.no"))) {
      sentence.push(AlpineI18n.t("60-results.sentenceNine.versionOne", { age }))
    }

    if (
      chronicOrAcuteDisease.includes(AlpineI18n.t("23-test.cardiovascularDiseases")) ||
      chronicOrAcuteDisease.includes(AlpineI18n.t("23-test.diabetes"))
    ) {
      sentence.push(
        " ",
        AlpineI18n.t("60-results.sentenceNine.versionTwo", { weightToLose: formattedWeightToLose })
      )
    }
    if (chronicOrAcuteDisease.includes(AlpineI18n.t("23-test.diseasesOfGastrointestinalTract"))) {
      sentence.push(" ", AlpineI18n.t("60-results.sentenceNine.versionThree"))
    }
    if (chronicOrAcuteDisease.includes(AlpineI18n.t("23-test.cholesterolProblems"))) {
      sentence.push(" ", AlpineI18n.t("60-results.sentenceNine.versionFour"))
    }

    return sentence.join("")
  },

  resultsSentenceTen() {
    const { healthComplaints } = this.formValues

    sentence = []

    if (
      healthComplaints.includes(AlpineI18n.t("24-test.optionTwo")) ||
      healthComplaints.includes(AlpineI18n.t("24-test.optionThree"))
    ) {
      sentence.push(AlpineI18n.t("60-results.sentenceTen.versionOne"))
    }
    if (
      healthComplaints.includes(AlpineI18n.t("24-test.optionFive")) ||
      healthComplaints.includes(AlpineI18n.t("24-test.optionSix"))
    ) {
      sentence.push(AlpineI18n.t("60-results.sentenceTen.versionTwo"))
    }

    return sentence.join("")
  },

  resultsSentenceEleven() {
    const { haveInfants } = this.formValues

    if (AlpineI18n.t("26-test.answerTwo") === haveInfants) {
      return AlpineI18n.t("60-results.sentenceEleven.versionOne")
    }
  },

  resultsSentenceTwelve() {
    const { allergies } = this.formValues

    if (allergies.includes(AlpineI18n.t("27-test.optionOne"))) {
      return AlpineI18n.t("60-results.sentenceTwelve.versionOne")
    } else {
      return AlpineI18n.t("60-results.sentenceTwelve.versionTwo")
    }
  },

  resultsSentenceThirteen() {
    return AlpineI18n.t("60-results.sentenceThirteen.versionOne")
  },

  resultsSentenceFourteen() {
    return AlpineI18n.t("60-results.sentenceFourteen.versionOne")
  },

  resultsSentenceFifteen() {
    const { feelingSleepyAfterMealOccurence } = this.formValues

    if (
      [AlpineI18n.t("31-test.answerThree"), AlpineI18n.t("31-test.answerFour")].includes(
        feelingSleepyAfterMealOccurence
      )
    ) {
      return AlpineI18n.t("60-results.sentenceFifteen.versionOne")
    }
  },

  resultsSentenceSixteen() {
    const { overeatPeriod } = this.formValues

    if (AlpineI18n.t("35-test.answerOne") === overeatPeriod) {
      return AlpineI18n.t("60-results.sentenceSixteen.versionOne")
    }
    if (AlpineI18n.t("35-test.answerTwo") === overeatPeriod) {
      return AlpineI18n.t("60-results.sentenceSixteen.versionTwo")
    }
    if (AlpineI18n.t("35-test.answerThree") === overeatPeriod) {
      return AlpineI18n.t("60-results.sentenceSixteen.versionThree")
    }
  },

  resultsSentenceSeventeen() {
    const { mealPreparingAvgTime } = this.formValues

    if (
      [AlpineI18n.t("37-test.answerOne"), AlpineI18n.t("37-test.answerTwo")].includes(
        mealPreparingAvgTime
      )
    ) {
      return AlpineI18n.t("60-results.sentenceSeventeen.versionOne")
    }
    if (
      [AlpineI18n.t("37-test.answerThree"), AlpineI18n.t("37-test.answerFour")].includes(
        mealPreparingAvgTime
      )
    ) {
      return AlpineI18n.t("60-results.sentenceSeventeen.versionTwo")
    }
  },

  resultsSentenceEighteen() {
    const { vegetablesPerDay } = this.formValues

    if (
      [AlpineI18n.t("40-test.answerOne"), AlpineI18n.t("40-test.answerTwo")].includes(
        vegetablesPerDay
      )
    ) {
      return AlpineI18n.t("60-results.sentenceEighteen.versionOne")
    }
  },

  resultsSentenceNineteen() {
    const { coffeeIntakeAmount } = this.formValues

    if (AlpineI18n.t("43-test.answerFour") === coffeeIntakeAmount) return

    return AlpineI18n.t("60-results.sentenceNineteen.versionOne")
  },

  resultsSentenceTwenty() {
    const { averageWorkingDay } = this.formValues

    if (AlpineI18n.t("44-test.answerThree") === averageWorkingDay) {
      return AlpineI18n.t("60-results.sentenceTwenty.versionOne")
    }
  },

  resultsSentenceTwentyOne() {
    const { workingOutOccurence } = this.formValues

    if (
      [AlpineI18n.t("51-test.answerOne"), AlpineI18n.t("51-test.answerTwo")].includes(
        workingOutOccurence
      )
    ) {
      return AlpineI18n.t("60-results.sentenceTwentyOne.versionOne")
    } else {
      return AlpineI18n.t("60-results.sentenceTwentyOne.versionTwo")
    }
  },

  resultsSentenceTwentyTwo(formattedWeightToLose) {
    const { bodyParts, gender } = this.formValues

    if (bodyParts === null) return

    if (gender === "male") {
      if (bodyParts.includes(AlpineI18n.t("54-test.chest"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionOne", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.shouldersAndArms"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionTwo", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.stomach"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionThree", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.buttocks"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionFour", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.thigs"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionFive", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.lowerLegs"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.men.versionFive", {
          weightToLose: formattedWeightToLose,
        })
      }
    } else {
      if (bodyParts.includes(AlpineI18n.t("54-test.chest"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.women.versionOne", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.shouldersAndArms"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.women.versionTwo", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.stomach"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.women.versionThree", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (bodyParts.includes(AlpineI18n.t("54-test.buttocks"))) {
        return AlpineI18n.t("60-results.sentenceTwentyTwo.women.versionFour", {
          weightToLose: formattedWeightToLose,
        })
      }
    }
  },

  resultsSentenceTwentyThree(formattedWeightToLose) {
    const { gender, motivationForLosingWeight } = this.formValues

    if (gender === "male") {
      if (AlpineI18n.t("55-test.motivationOneMan") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.men.versionOne")
      }
      if (AlpineI18n.t("55-test.motivationTwoMan") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.men.versionTwo", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (AlpineI18n.t("55-test.motivationThreeMan") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.men.versionThree", {
          weightToLose: formattedWeightToLose,
        })
      }
    } else {
      if (AlpineI18n.t("55-test.motivationOneWomen") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.women.versionOne", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (AlpineI18n.t("55-test.motivationOneWomen") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.women.versionTwo", {
          weightToLose: formattedWeightToLose,
        })
      }
      if (AlpineI18n.t("55-test.motivationOneWomen") === motivationForLosingWeight) {
        return AlpineI18n.t("60-results.sentenceTwentyThree.women.versionThree", {
          weightToLose: formattedWeightToLose,
        })
      }
    }
  },

  resultsSentenceTwentyFour(formattedWeight) {
    const { gender, overWeightCausedProblems } = this.formValues

    if (gender === "male") {
      if (AlpineI18n.t("56-test.weightCausedProblemsOneMan") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.men.versionOne")
      }
      if (AlpineI18n.t("56-test.weightCausedProblemsTwoMan") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.men.versionTwo")
      }
      if (AlpineI18n.t("56-test.weightCausedProblemsThreeMan") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.men.versionThree", {
          currentWeight: formattedWeight,
        })
      }
    } else {
      if (AlpineI18n.t("56-test.weightCausedProblemsOneWomen") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.women.versionOne")
      }
      if (AlpineI18n.t("56-test.weightCausedProblemsTwoWomen") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.women.versionTwo")
      }
      if (AlpineI18n.t("56-test.weightCausedProblemsThreeWomen") === overWeightCausedProblems) {
        return AlpineI18n.t("60-results.sentenceTwentyFour.women.versionThree", {
          currentWeight: formattedWeight,
        })
      }
    }
  },

  resultsSentenceTwentyFive(idealWeight) {
    const { gender } = this.formValues

    if (gender === "male") {
      return AlpineI18n.t("60-results.sentenceTwentyFive.men.versionOne", {
        targetWeightKg: idealWeight,
      })
    } else {
      return AlpineI18n.t("60-results.sentenceTwentyFive.women.versionOne", {
        targetWeightKg: idealWeight,
      })
    }
  },

  bodyMassIndex() {
    const { heightCm, weightKg } = this.formValues
    const heightM = heightCm / 100

    return parseFloat(weightKg / (heightM * heightM)).toFixed(1)
  },

  biologicalAge() {
    return this.formValues.age + 7
  },

  dailyBasalMetabolicRate() {
    const { gender, age, weightKg, heightCm } = this.formValues

    if (gender === "male") {
      return Math.round(88.362 + 13.397 * weightKg + 4.799 * heightCm - 5.677 * age)
    } else {
      return Math.round(447.593 + 9.247 * weightKg + 3.098 * heightCm - 4.33 * age)
    }
  },

  weightLossPotential() {
    const weightLostScore = Object.keys(this.formValues).reduce((prevVal, currentVal) => {
      let scores = this.scores()
      let score = scores[currentVal]

      if (score && score[this.formValues[currentVal]]) {
        return prevVal + score[this.formValues[currentVal]]
      } else {
        return prevVal + 0
      }
    }, 0)

    return weightLossTable[weightLostScore.toString()]
  },
})
